import { useCallback, useState } from 'react';
import type { RollRequest, RollResult, ClientMessage } from '@roll1/shared';
import type { DistributiveOmit } from './useMultiplayer';

export interface UseRollsReturn {
  lastRollResult: RollResult | null;
  sendRoll: (request: Omit<RollRequest, 'isWhisper'> & { isWhisper?: boolean }) => void;
  handleRollResult: (rollResult: RollResult) => void;
}

export function useRolls(
  send: (msg: DistributiveOmit<ClientMessage, 'id' | 'timestamp'>) => void,
): UseRollsReturn {
  const [lastRollResult, setLastRollResult] = useState<RollResult | null>(null);

  const sendRoll = useCallback(
    (request: Omit<RollRequest, 'isWhisper'> & { isWhisper?: boolean }) => {
      send({
        type: 'roll:request',
        sheetId: request.sheetId,
        rollName: request.rollName,
        expression: request.expression,
        fieldValues: request.fieldValues,
        isWhisper: request.isWhisper ?? false,
        isDualD20: request.isDualD20,
        attackDamage: request.attackDamage,
      });
    },
    [send],
  );

  const handleRollResult = useCallback((rollResult: RollResult) => {
    setLastRollResult(rollResult);
  }, []);

  return { lastRollResult, sendRoll, handleRollResult };
}
